import { useActiveAccount } from '..';

export default function ShowForRoles({ roles, children }) {
  const { showForRoles } = useActiveAccount();

  return showForRoles(roles) ? children : null;
}
